<template>
    <div class="news">
        <h2 class="news__title">Новости</h2>
        <div class="news__item" v-for="(item, index) in news" v-bind:key="item.SYS_GUID" v-b-toggle.sidebar-1 @click="getIndex(index)">
            <div class="item__title"><span>Заголовок</span></div>
            <div class="item__text">{{item.TEXT_NEWS.length > 100 ? item.TEXT_NEWS.slice(0, 100) + '...' : item.TEXT_NEWS}}</div>
            <div class="item__date">{{item.SYS_CREATED.substr(0, 16)}}</div>
        </div>

        <pager :items="total" :page="page" :limit="ppage" @setPage="page = $event" @setPerPage="ppage = $event"></pager>

        <b-sidebar
      id="sidebar-1"
      backdrop-variant="dark"
      backdrop
      shadow
      right
      :visible="open"
      width="50%"
      bg-variant="dark"
      text-variant="light"
      no-close-on-route-change
      class="p-2"
      lazy
    >
      <div class="sidebar__contanier">
        <h3>Заголовок</h3>
        <div v-html="news[i].MEMO"></div>
        <div class="item__text">{{news[i].TEXT_NEWS}}</div>
        <div class="item__date">{{news[i].SYS_CREATED}}</div>
      </div>
    </b-sidebar>
    </div>
</template>

<script>
import { apiQuery } from "../api";
import Pager from '@/components/Pager'
    export default {
        components: { Pager },
        data() {
            return {
                news: [],
                total: 0,
                ppage: 20,
                page: 1,
                i: 0
            }
        },
        watch: {
            filter: {
                handler () {
                    this.loading = true
                    setTimeout(() => { this.loadItems() }, 100)
                }
        },
        page: {
            handler () {
                this.loading = true
                this.loadItems()
            }
        },
        ppage: {
            handler () {
                this.loading = true
                this.loadItems()
            }
        }
    },
        mounted() {
            this.loadItems();
        },
        methods: {
            loadItems() {
                let params = {
                    table: window.x2.tables.news,
                    offset: (this.page - 1) * this.ppage,
                    limit: this.ppage
                }
                params['sort'] = [{
                    field: "DATE",
                    dir: "DESC"
                }]

                apiQuery('private', 'data-get-records', params, false).then(res => {
                    this.news = res.rows;
                    this.total = res.count;
                    this.loading = false;
                }).catch(e => {
                    console.error(e)
                })
            },
            getIndex(index) {
                this.i = index;
            }
        }
    }
</script>

<style scoped>
.news {
    padding: 40px 30px;
    min-height: 100vh;
}
.news__title {
    font-size: 1.75rem;
    color: aliceblue;
    font-weight: 500;
}
.news__item {
    color:aliceblue;
    margin-top: 50px;
    border-bottom: 1px solid grey;
    padding-bottom: 10px;
    cursor: pointer;
}
.item__title {
    font-size: 22px;
}
.item__title span {
    font-size: 1.50rem;
    font-weight: 500;
}
.item__date {
    font-size: 12px;
    display: flex;
    justify-content:flex-end ;
    margin-top: 20px;
    
}
.item__text {
    font-size: 18px;
    padding: 0 15px;
}
.sidebar__contanier {
    padding: 60px 80px;
}
</style>